import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { normalizeZipCode } from '~/schemas/customer/address'

interface IZipCodeState {
    /**
     * CEP do último frete calculado com sucesso pelo visitante (carrinho, PDP ou checkout), só com os dígitos; vazio
     * antes do primeiro cálculo. Lido pelo `usePreferredZipCode` e pelo `useNewAddressZipCode`.
     */
    zipCode: string
    /** Gravado pelos services de frete no sucesso; valor sem 8 dígitos é ignorado. */
    setZipCode: (zipCode: string) => void
    resetStore: () => void
}

const initialState = { zipCode: '' }

/**
 * CEP preferido do visitante, da sessão anônima à logada (o login vindo da sessão anônima não limpa as stores). É dado do
 * cliente: o `clearAllStores` o apaga no logout e na troca de cliente.
 */
export const useZipCodeStore = create<IZipCodeState>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                setZipCode: (zipCode) => {
                    const digits = normalizeZipCode(zipCode)
                    if (digits.length === 8) set({ zipCode: digits }, false, 'setZipCode')
                },
                resetStore: () => set(initialState, false, 'resetStore'),
            }),
            { name: 'zip-code-storage' },
        ),
        { name: 'zip-code-store' },
    ),
)
